import { cn, createBEM } from "@/libs";
import { useTimeout } from "ahooks";
import { BellOutline, SendOutline } from "antd-mobile-icons";
import { PropsWithChildren } from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";

export type NotificationProps = PropsWithChildren<{
  className?: string;
  duration?: number;
  onClose: () => void;
  title: string;
  content: string;
  onClick?: () => void;
}>;

const b = createBEM("i-notification");
export const Notification = ({
  className,
  duration = 3000,
  onClose,
  title,
  content,
  onClick,
}: NotificationProps) => {
  useTimeout(onClose, duration);
  return (
    <div className={cn(b(), className)} onClick={onClick}>
      <div className={b("top")}>
        <BellOutline className={b("icon")} />
        <span className={b("title")}>{title}</span>
        <SendOutline className={b("icon")} />
      </div>
      <div className={b("content")}>{content}</div>
    </div>
  );
};

export const notice = ({
  title,
  content,
  onClick,
}: {
  title: string;
  content: string;
  onClick?: () => void;
}): Promise<void> => {
  return new Promise((resolve) => {
    const div = document.createElement("div");
    const id = Math.random().toString(36).slice(2);
    div.id = id;
    const cp = (
      <Notification
        onClose={() => {
          root.unmount();
          div.remove();
          resolve();
        }}
        duration={5000}
        title={title}
        content={content}
        onClick={() => {
          onClick?.();
          root.unmount();
          div.remove();
          resolve();
        }}
      />
    );
    const root = createRoot(div);
    document.body.appendChild(div);
    root.render(cp);
  });
};
